<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Photo Gallery</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Photo Gallery</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <div *ngFor="let gallery of galleries">
            <h2 class="text-center mt-5">{{ gallery?.title }}</h2>
            <h5 class="text-center">{{ gallery?.sub_title }}</h5>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 mt-5 image-gallery"
                     *ngFor="let image of gallery?.images; let i =index;">
                    <img class="cover-background w-100 h-100 thumbnail img-custom" src="{{image?.url}}"/>
                </div>

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni2.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni3.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni4.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni5.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni6.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni7.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni8.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni9.jpg"/>-->
                <!--            </div>-->

                <!--            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">-->
                <!--                <img class="cover-background w-100 h-100" src="assets/img/hostel/arni10.jpg"/>-->
                <!--            </div>-->
            </div>
        </div>
    </div>
</section>
